<template>
    <div class="admin_parent">
        <div class="clearfix admin_nav">
            <div class="navig_logo fl">
                <img src="./../../assets/img/logo.png" alt="">
            </div>
            <div class="fr navig_div">
                <div class="navig_title">
                    <h3 class="fl">{{this.$store.state.schName}} - 校级管理端 </h3>
                    <span class="fr" @click="exit()">
                        <el-button type="info" size="small" plain>退出</el-button>
                    </span>
                </div>
            </div>
        </div>
        <div class="clearfix admin_all">
            <div class="fl admin_left">
                <el-menu
                    :default-active="activePath"
                    class="el-menu-vertical-demo"
                    :unique-opened='true'
                    background-color="#545c64"
                    text-color="#fff"
                    active-text-color="#ffd04b">
                    <router-link to="Userment">
                        <el-menu-item index="Userment">
                            <i class="iconfont icon-yonghuguanli" style="margin-right:10px;font-size:18px"></i>
                            <span slot="title">用户管理</span>
                        </el-menu-item>
                    </router-link>
                    <router-link to="FieldTeacher">
                        <el-menu-item index="FieldTeacher">
                            <i class="iconfont icon-yonghuguanli" style="margin-right:10px;font-size:18px"></i>
                            <span slot="title">教师管理</span>
                        </el-menu-item>
                    </router-link>
                    <el-submenu index="2">
                        <template slot="title">
                            <i class="iconfont icon-xiangmuguanli-" style="margin-right:10px;font-size:18px"></i>
                            <span>项目管理</span>
                        </template>
                        <router-link to="Batchcontrol">
                            <el-menu-item index="Batchcontrol">批次控制</el-menu-item>
                        </router-link>
                        <router-link to="Projectbatch">
                            <el-menu-item index="Projectbatch">项目审核</el-menu-item>
                        </router-link>
                        <!-- <router-link to="Alistofitems">
                            <el-menu-item index="Alistofitems">项目评审</el-menu-item>
                        </router-link> -->
                        <router-link to="Projectcation">
                            <el-menu-item index="Projectcation">项目申报</el-menu-item>
                        </router-link>
                        <router-link to="Projectcheck">
                            <el-menu-item index="Projectcheck">中期检查</el-menu-item>
                        </router-link>
                        <router-link to="Postreport">
                            <el-menu-item index="Postreport">结项报告</el-menu-item>
                        </router-link>
                    </el-submenu>
                    <router-link to="Matchingfunds">
                        <el-menu-item index="Matchingfunds">
                            <i class="iconfont icon-zijinguanli" style="margin-right:10px;font-size:18px"></i>
                            <span slot="title">资金管理</span>
                        </el-menu-item>
                    </router-link>
                    <el-submenu index="3">
                        <template slot="title">
                            <i class="iconfont icon-shujutongji" style="margin-right:10px;font-size:18px"></i>
                            <span>数据统计</span>
                        </template>
                        <router-link to="Patentstatistical">
                            <el-menu-item index="Patentstatistical">专利统计</el-menu-item>
                        </router-link>
                        <router-link to="Projectstatistics">
                            <el-menu-item index="Projectstatistics">项目统计</el-menu-item>
                        </router-link>
                        <router-link to="Moneystatistics">
                            <el-menu-item index="Moneystatistics">资金统计</el-menu-item>
                        </router-link>
                    </el-submenu>
                    <router-link to="AdminPassword">
                        <el-menu-item index="AdminPassword">
                            <i class="iconfont icon-zhanghaoguanli" style="margin-right:10px;font-size:18px"></i>
                            <span slot="title">修改密码</span>
                        </el-menu-item>
                    </router-link>
                    <el-menu-item index="4">
                        <i class="iconfont icon-xitongxiaoxi" style="margin-right:10px;font-size:18px"></i>
                        <span slot="title">系统消息</span>
                    </el-menu-item>
                </el-menu>
            </div>
            <div class="fr admin_right">
                <div class="bread_container">
                    <el-breadcrumb class="breadcrumb" separator="/">
                        <el-breadcrumb-item 
                            v-for='(name,index) in $route.meta'
                            :key='index'
                            >
                            {{name}}
                        </el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
                <div class="bread_view">
                    <router-view></router-view>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data () {
        return {
            activePath:'',
        }
    },
    methods: {
        exit(){
            this.$router.push({name:'login'})
        },
        getPath(){
            let currentPath = this.$route
            this.activePath = currentPath.name
            if(this.$route.name=="Projectdetails"){
                if(this.$route.query.val==1){
                    this.activePath = 'Projectbatch'
                }else if(this.$route.query.val==2){
                    this.activePath = 'Alistofitems'
                }else{
                    this.activePath = 'Projectcation'
                }
            }else{
                this.activePath = currentPath.name
            }
        },
    },
    watch:{
        $route(){
            this.getPath()
        }
    },
    mounted() {
        this.getPath()
    },
}
</script>
<style scoped>
@import './../../assets/css//admin/admin.css';
</style>
<style>
.admin_left .el-menu{
    border-right: none;
}
.admin_left .el-submenu__title i{
    color: #fff;
}
.admin_left .el-menu-item i{
    color: #fff;
}
.admin_left .is-active{
    background: rgb(67, 74, 80)!important;
}
</style>